import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "border-input placeholder:text-slate-400 focus-visible:border-primary focus-visible:ring-primary/20 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive flex field-sizing-content min-h-22 sm:min-h-26 w-full min-w-0 max-w-full rounded-lg border bg-white px-3.5 sm:px-4 py-2.5 sm:py-3 text-sm sm:text-[15px] text-foreground shadow-xs transition-[color,box-shadow,border-color] outline-none disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
